module.exports = __webpack_public_path__ + "static/about-insta-9-9cab88cb7ad8e393bd965b0e1100bdfa.jpg";